import React from "react";
import data from "./data";
import IntegrationCardList from "./integration-card-list/integration-card-list";

const IntegrationList = () => {
  return <IntegrationCardList data={data} />;
};

export default IntegrationList;
